import { useEffect, useState } from 'react';

// Single source of truth for the dark-mode toggle (was copy-pasted in
// DashboardLayout, LiteLayout, and SettingsPage — and SettingsPage skipped
// the init read, so its toggle could start out of sync). Reads localStorage
// first, falls back to the OS preference, and keeps <html class="dark"> in
// sync. All consumers share the 'theme' localStorage key.
export function useTheme() {
  const [isDarkMode, setIsDarkMode] = useState(() =>
    document.documentElement.classList.contains('dark')
  );

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia(
      '(prefers-color-scheme: dark)'
    ).matches;
    const shouldBeDark = savedTheme === 'dark' || (!savedTheme && prefersDark);
    setIsDarkMode(shouldBeDark);
    document.documentElement.classList.toggle('dark', shouldBeDark);
  }, []);

  const toggleDarkMode = () => {
    setIsDarkMode((prev) => {
      const next = !prev;
      document.documentElement.classList.toggle('dark', next);
      localStorage.setItem('theme', next ? 'dark' : 'light');
      return next;
    });
  };

  return { isDarkMode, toggleDarkMode };
}
